/** True when `raw` is an /app path that a URL parser resolves to itself.
 *  Dot segments (plain or %2e-encoded), `//`, backslashes and control
 *  characters are refused: /app/..//evil.com resolves to the path
 *  //evil.com, which any later re-serialisation turns into an off-site
 *  protocol-relative redirect (MKT-698). */
export function isSafeAppPath(raw: string): boolean {
  // eslint-disable-next-line no-control-regex
  if (raw.includes("\\") || /[\x00-\x1f\x7f]/.test(raw)) return false;
  const pathEnd = raw.search(/[?#]/);
  let path: string;
  try {
    path = decodeURIComponent(pathEnd === -1 ? raw : raw.slice(0, pathEnd));
  } catch {
    return false;
  }
  if (!isAppPathname(path) || path.includes("\\")) return false;
  if (path.split("/").some((segment) => segment === "." || segment === "..")) return false;
  try {
    return new URL(raw, "https://x.invalid").pathname === path;
  } catch {
    return false;
  }
}

/** /app or a path under it, and never a protocol-relative `//`. */
export function isAppPathname(pathname: string): boolean {
  return /^\/app(\/|$)/.test(pathname) && !pathname.includes("//");
}
